import { useEffect, useLayoutEffect, useRef, useState } from "react";
import Inventory from "../../dashboard/inventory/page";
import { useAppContext } from "../../../contexts/app";
import { Field, Input, Label, IncludesSpeakers, NumberOfCameras, DynamicSelectorButtons } from "../../../components/forms";
import { UseGoogleSheet } from "../../../hooks/UseGoogleSheets";
import { Button } from "../../../components/ctas";
import QCUnitStatus, { unitProgress } from "../../../components/qc-unit-status";
import { FieldsetWrapperFS } from "../unit/page";
import { Link } from "react-router-dom";

const TableauEmbed = () => {
	const vizRef = useRef(null);

	useEffect(() => {
	  const vizElement = vizRef.current;
	  if (vizElement) {
		vizElement.style.width = "100%";
		vizElement.style.height = `${vizElement.parentElement.offsetWidth * 0.75}px`;

		const scriptElement = document.createElement("script");
		scriptElement.src = "https://public.tableau.com/javascripts/api/viz_v1.js";
		scriptElement.async = true;
		vizElement.parentNode.insertBefore(scriptElement, vizElement);
	  }
	}, []);

	return (
	  <div
		className="tableauPlaceholder"
		id="viz1743186799076"
		style={{ position: "relative" }}
	  >
		<noscript>
		  <a href="#">
			<img
			  alt="FS Unit Progress"
			  src="https://public.tableau.com/static/images/Bo/Book1_17431867791100/Sheet1/1_rss.png"
			  style={{ border: "none" }}
			/>
		  </a>
		</noscript>
		<object
		  ref={vizRef}
		  className="tableauViz"
		  style={{ display: "none" }}
		>
		  <param name="host_url" value="https%3A%2F%2Fpublic.tableau.com%2F" />
		  <param name="embed_code_version" value="3" />
		  <param name="site_root" value="" />
		  <param name="name" value="Book1_17431867791100/Sheet1" />
		  <param name="tabs" value="no" />
		  <param name="toolbar" value="yes" />
		  <param
			name="static_image"
			value="https://public.tableau.com/static/images/Bo/Book1_17431867791100/Sheet1/1.png"
		  />
		  <param name="animate_transition" value="yes" />
		  <param name="display_static_image" value="yes" />
		  <param name="display_spinner" value="yes" />
		  <param name="display_overlay" value="yes" />
		  <param name="display_count" value="yes" />
		  <param name="language" value="en-US" />
		  <param name="filter" value="publish=yes" />
		</object>
	  </div>
	);
  };

const InventoryItem = ({ uuid, unitName, qcStatus, deployment, date, customer, PDI, status, mobile, address, site}) => {
	return <>
		<a href={`/fs/unit/${uuid}`}  className="tw-border tw-border-pink-white hover:tw-bg-white hover:tw-text-black tw-my-20px tw-p-10px tw-relative tw-block tw-w-full">
			<h1 className="tw-font-bold">{ unitName }</h1>
			<ul className="tw-grid tw-grid-cols-2 tw-gap-10px">
				<li>
					Customer: { customer }
				</li>
				<li>
					Status: { PDI }
				</li>
				<li>
					Ship Date: { date }
				</li>
				<li>
					Deployment Date: { deployment }
				</li>
				<li>
					Mobile: { mobile }
				</li>
			</ul>
			{ status && <span className="tw-block tw-mt-10px tw-mb-5px tw-text-[.8em]">
				Shipping Status: { status }
			</span> }
			<span className="tw-block tw-mt-10px tw-mb-5px tw-text-[.8em]">
				Address: { address }
			</span>
			<span className="tw-block tw-mt-10px tw-mb-5px tw-text-[.8em]">
				Site: { site }
			</span>
			{/* <QCUnitStatus subNavData={ subNavData } /> */}


			<span href={`/fs/unit/${uuid}`} className="tw-absolute tw-top-0 tw-right-0 tw-m-10px">
				<span className="tw-pointer-events-none">
					Edit
				</span>
			</span>
		</a>
		{/* <div className="tw-border tw-border-pink-200 tw-my-10 tw-p-5">
			<h1>{ unitName }</h1>
			<QCUnitStatus subNavData={ qcStatus } />
			<Link to={`/fs/unit/${uuid}`} className="tw-text-white tw-text-lg tw-font-bold tw-underline">
				<span className="tw-pointer-events-none tw-pt-5px">
					Edit
				</span>
			</Link>
		</div> */}
	</>
}

export default function FSInventory() {

	const appContext = useAppContext();
	// const [editMode, setEditMode] = useState(false);
	const [rows, setRows] = useState([]);
	const [qcRows, setQcRows] = useState([]);
	const [progressRows, setProgressRows] = useState([]);
	const [unitSearch, setUnitSearch] = useState("");

	//Units google sheet
	const { loadSheet, sheetRows, setRow, addRow, saveRow } = UseGoogleSheet({ spreadsheetId: process.env.REACT_APP_FS_UNITS });
	//Units QC PDI google sheet
	const { loadSheet: loadQCSheet, } = UseGoogleSheet({spreadsheetId: process.env.REACT_APP_FS_PDI });
	//Units QC Progress google sheet
	const { loadSheet: loadProgressSheet } = UseGoogleSheet({ spreadsheetId: process.env.REACT_APP_FS_PDI });

	useLayoutEffect(() => {
		loadSheet(true).then((sheets) => {
			setRows(sheets);
		});
		loadQCSheet(true).then((sheets) => {
			setQcRows(sheets);
		});
		loadProgressSheet(true, 1).then((sheets) => {
			setProgressRows(sheets);
		});
	}, []);


// Not Started
// Partial
// Failed

// Shipping Status
// 	Not Packed
// 	Packed
// 	Delivered
// 	Deployed

	// Filter rows based on the search input
	const filteredRows = rows.filter((row) => {
		const unitName = row.get("Unit Name");
		return unitName && unitName.toLowerCase().includes(unitSearch.toLowerCase());
	});

	const filteredRowsCompleted = rows.filter((row) => {
		const unitName = row.get("Unit Name");
		return unitName && unitName.toLowerCase().includes(unitSearch.toLowerCase()) && (row.get("PDI") === "Passed") && (row.get("Shipping Status") !== "Deployed") && (row.get("Shipping Status") !== "Shipped") && (row.get("Shipping Status") !== "Delivered");
	});


	const filteredRowsPartial = rows.filter((row) => {
		const unitName = row.get("Unit Name");
		return unitName && unitName.toLowerCase().includes(unitSearch.toLowerCase()) && (row.get("PDI") === "Partial");
	});


	const filteredRowsShipped = rows.filter((row) => {
		const unitName = row.get("Unit Name");
		return unitName && unitName.toLowerCase().includes(unitSearch.toLowerCase()) && (row.get("PDI") === "Passed") && ((row.get("Shipping Status") === "Shipped") || (row.get("Shipping Status") === "Delivered"));
	});


	const filteredRowsDeployed = rows.filter((row) => {
		const unitName = row.get("Unit Name");
		return unitName && unitName.toLowerCase().includes(unitSearch.toLowerCase()) && (row.get("PDI") === "Passed") && (row.get("Shipping Status") === "Deployed");
	});



	// const filterRowsByPDIStatus = (status) => {
	// 	return rows.filter((row) => {
	// 		const unitName = row.get("Unit Name");
	// 		return unitName && unitName.toLowerCase().includes(unitSearch.toLowerCase()) && (row.get("PDI") === status || "Passed");
	// 	});
	// }



	return <>
		<div className="tw-w-full">
			{ appContext.rows &&
				<div>
					<h1>Units</h1>

				 <FieldsetWrapperFS title="Search Units">
					<Field
					type="text"
					value={unitSearch}
					onChange={(e) => setUnitSearch(e.target.value)} // Update search state
					/>
					<Label>Search</Label>
				</FieldsetWrapperFS>



					<h1 className="tw-text-[2em] tw-uppercase tw-tracking-wider tw-w-full tw-pb-15px tw-pt-40px tw-relative">
						All Units
						<span className="tw-block tw-text-[.5em]">
							<a href="#deployed">Deployed</a>: {filteredRowsDeployed.length || 0}{` `}
							| {` `}<a href="#shipped">Shipped</a>: {filteredRowsShipped.length || 0}{` `}
							| {` `}<a href="#partial">Partial</a>: {filteredRowsPartial.length || 0}{` `}
							| {` `}<a href="#completed">Completed</a>: {filteredRowsCompleted.length || 0}
						</span>
					</h1>

					{/* Render Filtered Inventory Items */}
					{filteredRows.sort((a, b) => {
						const parse = (val) => {
							const str = String(val);
							const match = str.match(/^([^\d]+)\s*(\d+(?:\.\d+)?)/);
							if (!match) return [str, 0];
							const prefix = match[1].trim();
							const number = parseInt(match[2], 10); // only use integer part
							return [prefix, number];
						};

						const [prefixA, numA] = parse(a.get("Unit Name"));
						const [prefixB, numB] = parse(b.get("Unit Name"));

						if (prefixA === prefixB) {
							return numA - numB;
						}

						return prefixA.localeCompare(prefixB);
					}).map((row) => {
						const unitName = row.get("Unit Name");
						const uuid = row.get("UUID");
						const pdiItem = qcRows.find((qcRow) => qcRow.get('Unit Name') === unitName);

						return (
						uuid && (
							<InventoryItem
								status={row.get("Shipping Status") || "--"}
								PDI={row.get("PDI") || "--"}
								customer={row.get("Customer Name") || "--"}
								date={row.get("Delivery or Pickup Date") || "--"}
								deployment={row.get("Deployment Date") || "--"}
								address={row.get("Address") || "--"}
								mobile={row.get("Mobile") || "--"}
								site={row.get("Site") || "--"}
								key={uuid}
								uuid={uuid}
								unitName={unitName}
								key={uuid}
								uuid={uuid}
								unitName={unitName}
								qcStatus={unitProgress(pdiItem, pdiItem?._worksheet?._headerValues)}
							/>
						)
						);
					})}

					{/* Render Filtered Inventory Items + Status */}
					<h1 className="tw-text-[2em] tw-uppercase tw-tracking-wider tw-w-full tw-pb-15px tw-relative" id="completed">
						Completed Units ({filteredRowsCompleted.length || 0})
						<span className="tw-block tw-text-[.5em]">Ready to ship</span>
					</h1>
					{filteredRowsCompleted.map((row) => {
						const unitName = row.get("Unit Name");
						const uuid = row.get("UUID");
						const statusShipping = row.get("Shipping Status") || "--";
						const statusPDI = row.get("PDI") || "--";
						return (
							uuid && (
								<InventoryItem
								status={statusShipping}
								PDI={statusPDI}
								customer={row.get("Customer Name") || "--"}
								date={row.get("Delivery or Pickup Date") || "--"}
								deployment={row.get("Deployment Date") || "--"}
								address={row.get("Address") || "--"}
								mobile={row.get("Mobile") || "--"}
								site={row.get("Site") || "--"}
								key={uuid}
								uuid={uuid}
								unitName={unitName}
								/>
							)
						);
					})}


					{/* Render Filtered Inventory Items + Status */}
					<h1 className="tw-text-[2em] tw-uppercase tw-tracking-wider tw-w-full tw-pb-15px tw-relative" id="partial">
						Partial Units ({filteredRowsPartial.length || 0})
						<span className="tw-block tw-text-[.5em]">PDI Started</span>
					</h1>
					{filteredRowsPartial.map((row) => {
						const unitName = row.get("Unit Name");
						const uuid = row.get("UUID");
						const statusShipping = row.get("Shipping Status") || "--";
						const statusPDI = row.get("PDI") || "--";
						return (
							uuid && (
								<InventoryItem
								status={statusShipping}
								PDI={statusPDI}
								customer={row.get("Customer Name") || "--"}
								date={row.get("Delivery or Pickup Date") || "--"}
								deployment={row.get("Deployment Date") || "--"}
								address={row.get("Address") || "--"}
								mobile={row.get("Mobile") || "--"}
								site={row.get("Site") || "--"}
								key={uuid}
								uuid={uuid}
								unitName={unitName}
								/>
							)
						);
					})}



					{/* Render Filtered Inventory Items + Status */}
					<h1 className="tw-text-[2em] tw-uppercase tw-tracking-wider tw-w-full tw-pb-15px tw-relative" id="shipped">
						Shipped Units ({filteredRowsShipped.length || 0})
						<span className="tw-block tw-text-[.5em]">Units in transit or shipped but not deployed</span>
					</h1>
					{filteredRowsShipped.map((row) => {
						const unitName = row.get("Unit Name");
						const uuid = row.get("UUID");
						const statusShipping = row.get("Shipping Status") || "--";
						const statusPDI = row.get("PDI") || "--";
						return (
							uuid && (
								<InventoryItem
								status={statusShipping}
								PDI={statusPDI}
								customer={row.get("Customer Name") || "--"}
								date={row.get("Delivery or Pickup Date") || "--"}
								deployment={row.get("Deployment Date") || "--"}
								address={row.get("Address") || "--"}
								mobile={row.get("Mobile") || "--"}
								site={row.get("Site") || "--"}
								key={uuid}
								uuid={uuid}
								unitName={unitName}
								/>
							)
						);
					})}


					{/* Render Filtered Inventory Items + Status */}
					<h1 className="tw-text-[2em] tw-uppercase tw-tracking-wider tw-w-full tw-pb-15px tw-relative" id="deployed">
						Deployed Units ({filteredRowsDeployed.length || 0})
						<span className="tw-block tw-text-[.5em]">Live units</span>
					</h1>
					{filteredRowsDeployed.map((row) => {
						const unitName = row.get("Unit Name");
						const uuid = row.get("UUID");
						const statusShipping = row.get("Shipping Status") || "--";
						const statusPDI = row.get("PDI") || "--";
						return (
							uuid && (
								<InventoryItem
								status={statusShipping}
								PDI={statusPDI}
								customer={row.get("Customer Name") || "--"}
								date={row.get("Delivery or Pickup Date") || "--"}
								deployment={row.get("Deployment Date") || "--"}
								address={row.get("Address") || "--"}
								mobile={row.get("Mobile") || "--"}
								site={row.get("Site") || "--"}
								key={uuid}
								uuid={uuid}
								unitName={unitName}
								/>
							)
						);
					})}



				</div>
			}
		</div>
	</>
}
